import { FERNIE_FONT_CODE, FERNIE_FONT_VOICE } from "~/themes/fernieBrand";

export type FernieTextRole = "code" | "prose" | "status";

const resolveFernieFontFamily = (role: FernieTextRole): string | undefined => {
	switch (role) {
		case "code":
			return FERNIE_FONT_CODE;
		case "status":
			return FERNIE_FONT_VOICE;
		case "prose":
			return undefined;
	}
};

export default resolveFernieFontFamily;
